var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12,
    fill: "#FFEDB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6059 6.50313C13.1074 5.24245 14.8918 5.24245 15.3934 6.50313L16.9092 10.3132L20.9935 10.6555C22.3047 10.7654 22.8491 12.3899 21.8689 13.2677L18.7074 16.099L19.6514 20.2366C19.9499 21.5446 18.5124 22.5565 17.3817 21.8345L14.8069 20.1903C14.3146 19.876 13.6846 19.876 13.1923 20.1903L10.6176 21.8345C9.48684 22.5565 8.04942 21.5446 8.34785 20.2366L9.2919 16.099L6.13033 13.2677C5.15014 12.3899 5.69454 10.7654 7.00574 10.6555L11.0901 10.3132L12.6059 6.50313Z",
    fill: "#FF9200"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.83fabd45d02009a71ef3cfce8341ebae.svg";
export { ForwardRef as ReactComponent };